const SupportBtn = () => {
	return <a href="https://ko-fi.com/bestiary" className="support_btn">Support Us</a>;
};

export default SupportBtn;
